import { render } from "./Nomenclature.vue?vue&type=template&id=344884bd&scoped=true"
import script from "./Nomenclature.vue?vue&type=script&lang=js"
export * from "./Nomenclature.vue?vue&type=script&lang=js"

import "./Nomenclature.vue?vue&type=style&index=0&id=344884bd&scoped=true&lang=scss"

import exportComponent from "/builds/common/delivery-front/dev-factory/supplyweb/opticam/packages/webapp/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-344884bd"]])

export default __exports__